import { render, staticRenderFns } from "./a-header.vue?vue&type=template&id=bc4999c6&scoped=true&"
import script from "./a-header.vue?vue&type=script&lang=js&"
export * from "./a-header.vue?vue&type=script&lang=js&"
import style0 from "./a-header.vue?vue&type=style&index=0&id=bc4999c6&prod&lang=css&"
import style1 from "./a-header.vue?vue&type=style&index=1&id=bc4999c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4999c6",
  null
  
)

export default component.exports